module.exports = __webpack_public_path__ + "static/media/apr2025_decarbon.876f1eae.webp";